var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "b-button",
            {
              staticClass: "mr-2",
              attrs: { href: "/adm/metas/", variant: "primary", size: "sm" }
            },
            [
              _c("i", { staticClass: "fa fa-tasks" }),
              _vm._v(" Visualizar Metas")
            ]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mr-2",
              attrs: {
                variant: "primary",
                size: "sm",
                href: "/adm/metas/graph"
              }
            },
            [
              _c("i", { staticClass: "fas fa-chart-bar" }),
              _vm._v(" Ver Indicadores")
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "mt-3" }, [_vm._v("Pedidos Bonificados")]),
      _vm._v(" "),
      _c(
        "b-card",
        { staticClass: "mt-1" },
        [
          _c(
            "b-row",
            { staticClass: "mb-3" },
            [
              _c(
                "b-col",
                { attrs: { lg: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: { "label-for": "filter-input", "label-size": "sm" }
                    },
                    [
                      _c(
                        "b-input-group",
                        [
                          _c("b-form-input", {
                            attrs: {
                              size: "sm",
                              id: "filter-input",
                              type: "search",
                              placeholder: "Buscar Distribuidor"
                            },
                            model: {
                              value: _vm.filter,
                              callback: function($$v) {
                                _vm.filter = $$v
                              },
                              expression: "filter"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-input-group-append",
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { size: "sm", disabled: !_vm.filter },
                                  on: {
                                    click: function($event) {
                                      _vm.filter = ""
                                    }
                                  }
                                },
                                [_vm._v("Limpar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "sm" },
                      on: {
                        click: function($event) {
                          return _vm.getPedidoB()
                        }
                      }
                    },
                    [_vm._v("Buscar")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-table", {
            staticClass: "mt-1",
            attrs: {
              busy: _vm.loading,
              items: _vm.pedidos,
              fields: _vm.fields,
              stacked: "md",
              "show-empty": "",
              hover: "",
              "current-page": _vm.currentPage,
              "per-page": _vm.perPage,
              filter: _vm.filter,
              "filter-included-fields": _vm.filterOn,
              "sort-direction": _vm.sortDirection,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc
            },
            on: {
              filtered: _vm.onFiltered,
              "update:sortBy": function($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function($event) {
                _vm.sortDesc = $event
              }
            },
            scopedSlots: _vm._u([
              {
                key: "table-busy",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "text-center text-danger my-2" },
                      [
                        _c("b-spinner", { staticClass: "align-middle" }),
                        _vm._v(" "),
                        _c("strong", [_vm._v("Buscando...")])
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "cell(aprovado)",
                fn: function(row) {
                  return [
                    row.value
                      ? _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "success",
                              size: "sm",
                              disabled: "",
                              title: "Bonificação Aprovada"
                            }
                          },
                          [
                            _c("i", { staticClass: "fas fa-check" }),
                            _vm._v(" Bonificação Aprovada")
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !row.value
                      ? _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "warning",
                              size: "sm",
                              title: "Aguardando Aprovação"
                            },
                            on: {
                              click: function($event) {
                                return _vm.setAprova(row.item.id)
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fas fa-exclamation" }),
                            _vm._v(" Aprovar\n        ")
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "danger",
                          title: "Deletar Bonificação"
                        },
                        on: {
                          click: function($event) {
                            return _vm.Deletar(row.item.id)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-trash" })]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "fill",
              size: "sm"
            },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Gerar Bonificação" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _vm.bonificacao_id > 0
                    ? _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-block",
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: {
                              click: function($event) {
                                return _vm.Deletar(_vm.bonificacao_id)
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "fas fa-trash" }),
                            _vm._v(" Deletar\n        ")
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { href: "#", variant: "primary", size: "sm" },
                      on: { click: _vm.Salvar }
                    },
                    [_c("i", { staticClass: "fa fa-save" }), _vm._v(" Salvar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.modalBonifica = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalBonifica,
            callback: function($$v) {
              _vm.modalBonifica = $$v
            },
            expression: "modalBonifica"
          }
        },
        [
          _c(
            "b-card",
            [
              _c("b-card-body", [
                _c(
                  "ul",
                  { staticClass: "text-danger" },
                  _vm._l(_vm.errors, function(error) {
                    return _c("li", { key: error }, [_vm._v(_vm._s(error))])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12" },
                    [
                      _c("label", { attrs: { for: "distribuidor" } }, [
                        _vm._v("Selecione o Distribuidor:")
                      ]),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          id: "distribuidor",
                          options: _vm.listaDistribuidor,
                          disabled: !_vm.showDistribuidor,
                          onSearch: _vm.loadDistribuidor
                        },
                        model: {
                          value: _vm.distribuidor,
                          callback: function($$v) {
                            _vm.distribuidor = $$v
                          },
                          expression: "distribuidor"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-3" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12" },
                    [
                      _c("label", { attrs: { for: "dataExp" } }, [
                        _vm._v("Data de Expiração da Bonificação")
                      ]),
                      _vm._v(" "),
                      _c("date-picker", {
                        attrs: { id: "dataExp", config: _vm.datePickerConfig },
                        model: {
                          value: _vm.data_expira,
                          callback: function($$v) {
                            _vm.data_expira = $$v
                          },
                          expression: "data_expira"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-3" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("label", { attrs: { for: "valorBon" } }, [
                      _vm._v("Valor R$ - ")
                    ]),
                    _c("small", [_vm._v(" Informe o valor da bonificação:")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.valor,
                          expression: "valor"
                        },
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: [
                            "#.##",
                            "##.##",
                            "###.##",
                            "####.##",
                            "#####.##",
                            "######.##"
                          ],
                          expression:
                            "[\n                '#.##',\n                '##.##',\n                '###.##',\n                '####.##',\n                '#####.##',\n                '######.##',\n              ]"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: "valorBon", type: "text" },
                      domProps: { value: _vm.valor },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.valor = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3be8da57", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3be8da57","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/pedidos/Bonificados.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3be8da57","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/pedidos/Bonificados.vue
// module chunks = 2